import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { ReportsComponent } from './reports.component';
import { ReportsRoutingModule } from './reports-routing.module';
import {MatRadioModule} from '@angular/material/radio';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DxReportViewerModule} from 'devexpress-reporting-angular';
import { MatInputModule } from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { ReportViewerDialogComponent } from './report-viewer-dialog/report-viewer-dialog.component';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {MatDialogModule} from '@angular/material/dialog';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatListModule} from '@angular/material/list';
import { ReportAgingFilterComponent } from './report-viewer-filters/report-aging-filter/report-aging-filter.component';
import {MaterialModule} from '../material.module';
import { ReportAdaParametersComponent } from './report-viewer-parameters/report-ada-parameters/report-ada-parameters.component';
import { ReportFinancialSummaryFilterComponent } from './report-viewer-filters/report-financial-summary-filter/report-financial-summary-filter.component';
import { ReportFinancialSnapshotFiltersComponent } from './report-viewer-filters/report-financial-snapshot-filters/report-financial-snapshot-filters.component';
import { ReportFinancialSnapshotComponent } from './report-financial-snapshot/report-financial-snapshot.component';
import {DxDataGridModule} from 'devextreme-angular';
import {DxiRowModule} from 'devextreme-angular/ui/nested';
import { ReportFinancialSnapshotDetailComponent } from './report-financial-snapshot/report-financial-snapshot-detail/report-financial-snapshot-detail.component';
import { ReportFrontDeskFiltersComponent } from './report-viewer-filters/report-front-desk-filters/report-front-desk-filters.component';


@NgModule({
  declarations: [ReportsComponent, ReportViewerComponent, ReportViewerDialogComponent, ReportAgingFilterComponent, ReportAdaParametersComponent, ReportFinancialSummaryFilterComponent, ReportFinancialSnapshotFiltersComponent, ReportFinancialSnapshotComponent, ReportFinancialSnapshotDetailComponent, ReportFrontDeskFiltersComponent],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    MatRadioModule,
    MatFormFieldModule,
    FormsModule,
    DxReportViewerModule,
    MatInputModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    TdoControlsModule,
    MatDialogModule,
    DragDropModule,
    MatListModule,
    MaterialModule,
    ReactiveFormsModule,
    DxDataGridModule,
    DxiRowModule
  ]
})
export class ReportsModule { }
